import React from 'react';
import { Badge } from '@/components/ui/badge';

const MAP = {
  template: {
    APPROVED: 'bg-[#EAF8F1] text-[#0F6B45] border-[#86EFAC]',
    PENDING:  'bg-[#FFF3E8] text-[#9A3412] border-[#FDBA74] status-pending-pulse',
    REJECTED: 'bg-[#FEECEE] text-[#9F1239] border-[#FDA4AF]',
    DRAFT:    'bg-white/70 text-[hsl(var(--foreground))] border-white/60',
    DISABLED: 'bg-gray-100 text-gray-600 border-gray-300',
  },
  campaign: {
    DRAFT:     'bg-white/70 text-[hsl(var(--foreground))] border-white/60',
    SCHEDULED: 'bg-[#E6F6FF] text-[#075985] border-[#7DD3FC]',
    SENDING:   'bg-[#FFF7ED] text-[#9A3412] border-[#FDBA74] status-pending-pulse',
    COMPLETED: 'bg-[#EAF8F1] text-[#0F6B45] border-[#86EFAC]',
    FAILED:    'bg-[#FEECEE] text-[#9F1239] border-[#FDA4AF]',
    CANCELLED: 'bg-gray-100 text-gray-600 border-gray-300',
  },
  message: {
    pending:   'bg-white/70 text-[hsl(var(--foreground))] border-white/60',
    sent:      'bg-[#FFF7ED] text-[#9A3412] border-[#FDBA74]',
    delivered: 'bg-[#EAF8F1] text-[#0F6B45] border-[#86EFAC]',
    read:      'bg-[#E6F6FF] text-[#075985] border-[#7DD3FC]',
    failed:    'bg-[#FEECEE] text-[#9F1239] border-[#FDA4AF]',
  },
};

export default function StatusBadge({ status, kind = 'template' }) {
  const cls = (MAP[kind] || {})[status] || 'bg-white/70 text-[hsl(var(--foreground))] border-white/60';
  return (
    <Badge variant="outline" className={`px-2.5 py-0.5 rounded-full font-semibold text-[11px] uppercase tracking-wide ${cls}`} data-testid={`status-badge-${kind}-${status}`}>
      {status}
    </Badge>
  );
}
